import { ArchetypeDefinition } from '../../archetypeTypes';

export const CARE_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'healer',
        name: 'Healer',
        description: 'Breath harmony and coherence increasing resilience.',
        category: 'Care',
        tags: ['coherence', 'restoration', 'harmony'],
        weights: { breathingQuality: 0.5, stability: 0.25, energyLevel: 0.25 }
    },
    {
        key: 'caregiver',
        name: 'Caregiver',
        description: 'Stabilizing connections and sustaining energy for others.',
        category: 'Care',
        tags: ['support', 'sustain', 'safety'],
        weights: { stability: 0.35, edgeCount: 0.2, averageNodeEnergy: 0.2, breathingQuality: 0.25 }
    },
    {
        key: 'guardian',
        name: 'Guardian',
        description: 'Protection at thresholds; buffers shocks and preserves coherence.',
        category: 'Care',
        tags: ['protection', 'buffer', 'threshold'],
        weights: { stability: 0.35, waveIntensity: 0.15, edgeCount: 0.25, breathingQuality: 0.25 }
    }
];


